<template>
  <div class="col-12 form-contact-1 px-sm-0">
    <div class="col-12 text-center py-0">
      <span class="color-palette-4 font-weight-bold" style="font-size: 0.8rem">Déjanos tus datos para contactarte</span>
    </div>
    <hr />
    <form :id="id" @submit.prevent="sendContactForm" method="POST" autocomplete="off">
      <input type="hidden" name="_token" :value="csrf" />
      <input type="hidden" name="salary" :value="form.salary" />
      <input type="hidden" name="project_id" :value="project" />
      <input type="hidden" name="slug" :value="slug" />
      <input type="hidden" name="entrada" :value="entrada" />
      <input type="hidden" name="subsidy" :value="form.subsidy" />
      <div class="col pt-0 pb-2">
        <input type="text" placeholder="Nombre Completo" name="name" v-model.trim="$v.form.name.$model" :class="!$v.form.name.$anyError
          ? 'form-control input-contacto-1'
          : 'form-control input-contacto-1 form-error'
          " />
        <div class="error-data" v-if="$v.form.name.$dirty">
          <span v-if="!$v.form.name.required">Campo necesario</span>
        </div>
      </div>
      <div class="col pt-0 pb-2">
        <input type="text" placeholder="R.U.T" name="rut" v-rut:live v-model.trim="$v.form.rut.$model" :class="!$v.form.rut.$anyError
          ? 'form-control input-contacto-1'
          : 'form-control input-contacto-1 form-error'
          " />
        <div class="error-data" v-if="$v.form.rut.$dirty">
          <span v-if="!$v.form.rut.rutValidation || !$v.form.rut.minLength">RUT Inválido</span>
        </div>
      </div>
      <div class="col pt-0 pb-2">
        <input type="text" placeholder="Email" name="email" v-model.trim="$v.form.email.$model" :class="!$v.form.email.$anyError
          ? 'form-control input-contacto-1'
          : 'form-control input-contacto-1 form-error'
          " />
        <div class="error-data" v-if="$v.form.email.$dirty">
          <span v-if="!$v.form.email.required">Campo necesario</span>
          <span v-if="!$v.form.email.email">Email inválido</span>
        </div>
      </div>
      <div class="col pt-0 pb-2">
        <input type="text" placeholder="Teléfono de contacto" name="phone" onpaste="return false;" maxlength="9"
          @keypress="onlyNumber" v-model.trim="$v.form.phone.$model" :class="!$v.form.phone.$anyError
            ? 'form-control input-contacto-1'
            : 'form-control input-contacto-1 form-error'
            " />
        <div class="error-data" v-if="$v.form.phone.$dirty">
          <span v-if="!$v.form.phone.required">Campo necesario</span>
          <span v-if="!$v.form.phone.minLength">Teléfono inválido</span>
          <span v-if="!$v.form.phone.maxLength">Teléfono inválido</span>
        </div>
      </div>
      <div class="col pt-0 pb-2">
        <v-select-c style="border-radius: 9px !important" v-model="$v.form.salary.$model" :options="salary_ranges"
          label="text" :class="!$v.form.salary.$anyError ? '' : 'form-error'" :reduce="(text) => text.id"
          placeholder="Renta líquida">
        </v-select-c>
        <div class="error-data" v-if="$v.form.salary.$dirty">
          <span v-if="!$v.form.salary.required">Campo necesario</span>
        </div>
      </div>
      <div class="col pt-0 pb-2">
        <v-select-c style="border-radius: 9px !important" v-model="$v.form.subsidy.$model" :options="subsidy_types"
          label="text" :class="!$v.form.subsidy.$anyError ? '' : 'form-error'" :reduce="(text) => text.id"
          placeholder="Tipo subsidio">
        </v-select-c>
        <div class="error-data" v-if="$v.form.subsidy.$dirty">
          <span v-if="!$v.form.subsidy.required">Campo necesario</span>
        </div>
      </div>
      <div class="col">
        <button type="submit" :disabled="formLoading" class="btn btn-block btn-form-contact-1">
          {{ btnText }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import {
  required,
  minLength,
  email,
  maxLength,
} from "vuelidate/lib/validators";
import { rutValidator, rutInputDirective } from "vue-dni";

import Vue from "vue";
Vue.directive("rut", rutInputDirective);

export default {
  name: "ContactFormSection",
  props: {
    project: Number,
    slug: String,
    id: String
  },
  data: () => ({
    csrf: document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content"),
    formLoading: false,
    btnText: "Enviar",
    form: {
      name: "",
      rut: "",
      email: "",
      phone: "",
      salary: "",
      project_id: 0,
      entrada: "",
      subsidy: "",
    },
    salary_ranges: [
      { id: "$400.001 - $800.000", text: "$400.001 - $800.000" },
      { id: "$800.001 - $1.000.000", text: "$800.001 - $1.000.000" },
      { id: "$1.000.001 - $1.300.000", text: "$1.000.001 - $1.300.000" },
      { id: "$1.300.001 - $1.600.000", text: "$1.300.001 - $1.600.000" },
      { id: "$1.600.001 - $2.000.000", text: "$1.600.001 - $2.000.000" },
      { id: "más de $2.000.000", text: "más de $2.000.000" },
    ],
    subsidy_types: [
      { id: "no tengo subsidio", text: "no tengo subsidio" },
      { id: "ds1 tramo 1", text: "ds1 tramo 1" },
      { id: "ds1 tramo 2", text: "ds1 tramo 2" },
      { id: "ds1 tramo 3", text: "ds1 tramo 3" },
      { id: "ds49", text: "ds49" },
      { id: "otro subsidio", text: "otro subsidio" },
    ],
    entrada: localStorage.getItem("entrada"),
  }),
  methods: {
    sendContactForm(event) {
      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        this.btnText = "Enviando...";
        this.formLoading = true;
        const rutaForm = window.BASE_URL + "/add-contact-form";
        $(`#${this.id}`).attr("action", rutaForm).submit();
      }
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
  },
  validations: {
    form: {
      rut: {
        required,
        rutValidation: rutValidator,
        minLength: minLength(9),
      },
      name: {
        required,
      },
      phone: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9),
      },
      email: {
        required,
        email,
      },
      salary: {
        required,
      },
      subsidy: {
        required,
      }
    },
  },
};
</script>

<style scoped>
.input-contacto-1 {
  height: 30px;
  border-radius: 9px;
  font-size: 0.7rem;
}

.error-data {
  font-size: 0.75rem !important;
}
</style>
